// _gcl_aw / _gcl_gb hold GCL.<timestamp>.<click id>[.<suffix>]; the click id is always the third segment
export function parseGclCookie(value: string | undefined): string | undefined {
  return value?.match(/^GCL\.\d+\.([^.]+)/)?.[1];
}

// _gcl_ag holds e.g. 2.1.k<gbraid>$i<timestamp>$b<suffix>
export function parseGclAgCookie(value: string | undefined): string | undefined {
  return value?.match(/(?:^|\.)k([^$.]+)\$i\d+(?:\$|$)/)?.[1];
}

// _twclid holds URI-encoded JSON from X's pixel, e.g. {"twclid":"<click id>","pixelVersion":"2.0",...};
// some cookie parsers hand it over already decoded
export function parseTwclidCookie(value: string | undefined): string | undefined {
  if (!value) return undefined;
  try {
    const json = value.startsWith('{') ? value : decodeURIComponent(value);
    const twclid: unknown = JSON.parse(json)?.twclid;
    return typeof twclid === 'string' && twclid !== '' ? twclid : undefined;
  } catch {
    return undefined;
  }
}
